import { classNames } from "helpers/ClassNameHelper";
import React, { useContext, useRef } from "react";
import ReactDOM from "react-dom";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    isActive: boolean;
    modalHeader: React.ReactNode;
    modalFooter?: React.ReactNode;
    onClose: () => void;
    className?: string;
    maintainWidth?:
        | 10
        | 15
        | 20
        | 25
        | 30
        | 35
        | 40
        | 45
        | 50
        | 55
        | 60
        | 65
        | 70
        | 75
        | 80
        | 85
        | 90
        | 95
        | 100;
    maintainHeight?:
        | 10
        | 15
        | 20
        | 25
        | 30
        | 35
        | 40
        | 45
        | 50
        | 55
        | 60
        | 65
        | 70
        | 75
        | 80
        | 85
        | 90
        | 95
        | 100;
}
export const Modal: React.FC<Props> = ({
    children,
    isActive,
    modalHeader,
    modalFooter,
    className,
    maintainWidth,
    maintainHeight,
}) => {
    const modalRef = useRef<HTMLDivElement>(null);
    const { lowVision } = useContext(AccessibilityContext);

    if (!isActive) {
        return null;
    }
    const existingRoot = document.querySelector("#modal");
    const parent = existingRoot ?? createRootElement("modal");

    return ReactDOM.createPortal(
        <>
            <div className="modal-overlay" />
            <div className="modal-content">
                <div
                    className="modal-box"
                    style={{
                        minWidth: maintainWidth ? `${maintainWidth}%` : undefined,
                        minHeight: maintainHeight ? `${maintainHeight}vh` : undefined,
                        maxHeight: maintainHeight ? `${maintainHeight}vh` : undefined,
                        backgroundColor: lowVision ? "var(--darkgray)" : undefined,
                    }}
                >
                    <div ref={modalRef} className={classNames("modal-container", className)}>
                        {modalHeader}
                        {children}
                        {modalFooter}
                    </div>
                </div>
            </div>
        </>,
        parent
    );
};

function createRootElement(id: string) {
    const rootContainer = document.createElement("div");
    rootContainer.setAttribute("id", id);
    return rootContainer;
}
